import { useState, type FormEvent } from "react";
import { api, type Principal } from "../lib/api";

export function Login({ onLogin }: { onLogin: (principal: Principal) => void }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      onLogin(await api.login(email, password));
    } catch {
      // One message for unknown email, wrong password and disabled account, matching
      // the API. Anything more specific turns the form into an account-existence oracle.
      setError("Those credentials were not accepted.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="login">
      <form className="card" onSubmit={submit} data-testid="login-form">
        <h1>soulsearch</h1>
        <p style={{ color: "var(--ink-soft)", marginTop: 0 }}>
          Sign in to reach your datasets.
        </p>

        <label htmlFor="email" className="eyebrow">
          Email
        </label>
        <input
          id="email"
          type="email"
          autoComplete="username"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <label htmlFor="password" className="eyebrow">
          Password
        </label>
        <input
          id="password"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        {error && (
          <p data-testid="login-error" style={{ color: "var(--danger)" }}>
            {error}
          </p>
        )}

        <button className="primary" type="submit" disabled={busy}>
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </main>
  );
}
